import { registerNsbEventResetter } from './nsbEventReset';
import { INTELLIGENT_COUNTER_OFFER } from './nsbSelectionStore';

/**
 * Whether a stored negotiation source is the backend's ICO FALLBACK rather than a settled price.
 *
 * The backend stamps `intelligent_counter_offer` on any row saved at a zero starting price while ICO is on
 * for the event (bidops-app PrepareModelsToUpdateAction): "nothing priced this row, so ICO will after
 * round 1". That is not a decision, so precedence is a buyer's decision, then a smart baseline match, then
 * this fallback. Read as settled, the row is never seeded and a matched item sits at $0 under an ICO label.
 *
 * Only an unpriced row counts. Once ICO has filled it, the source describes a real price.
 */
export const isPendingIcoSource = (
  source: string | null | undefined,
  negotiationPrice: number | string | null | undefined,
): boolean => {
  if (source !== INTELLIGENT_COUNTER_OFFER) return false;
  if (negotiationPrice == null || negotiationPrice === '') return true;
  const price = Number(negotiationPrice);

  return Number.isNaN(price) || price <= 0;
};

const icoFallbackKeys = new Set<string>();

export const markIcoFallback = (sbKey: string): void => {
  if (sbKey) icoFallbackKeys.add(sbKey);
};

export const isIcoFallback = (sbKey: string | null): boolean => (sbKey ? icoFallbackKeys.has(sbKey) : false);

/**
 * A row ICO still owns: its negotiation source is ICO and it is not a replaceable fallback (a live event, an
 * explicit pick, or a row ICO has already priced). Nothing may price it from a smart baseline flavour.
 */
export const isHeldForIco = (negotiationSource: string | null | undefined, sbKey: string): boolean => (
  negotiationSource === INTELLIGENT_COUNTER_OFFER && !isIcoFallback(sbKey)
);

registerNsbEventResetter(() => { icoFallbackKeys.clear(); });
